<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  </div>
</template>

<script>
import { mgop } from '@aligov/jssdk-mgop';

mgop({
  api: 'mgop.xfw.huijing.doLogin', // 必填
  host: 'https://mapi-jcss.police.hangzhou.gov.cn', 
  dataType: 'JSON', 
  type: 'GET ', 
  appKey: 'vzpd1lm5+2001400101+fpoyfg', // 必填
  onSuccess: data => {
    var result = data.data;
    console.log("result ==  ", result)
    if (result.code == 0) {
      // alert(result.data)
      window.location.href = result.data;
    }
  },onFail: err => {
    console.log('err == ', err)
  }
});

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
